import { Box, styled } from "@mui/material"
import { colors } from "../theme/colors"


export const CloseButton = {
  width: "100%",
  fontSize: "14px",
  fontWeight: 500,
}

export const ItemContainer = styled(Box)({
  display: "flex",
  gap: 14,
  alignItems: "center",
})

export const ItemDescriptionContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
})

export const WhiteCard = styled(Box)({
  padding: 20,
  boxShadow: `0 10px 16px ${colors.shadowGrey}`,
  borderRadius: 20,
})

export const AuthTitle = {
  marginBottom: "20px",
  maxWidth: 250,
}

export const AuthAgreement = {
  marginBottom: "20px",
}

export const AuthSubtitle = {
  marginBottom: "50px",
  maxWidth: 250,
  fontWeight: 400,
}